import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    ressourcenPlan: result,
    isLoading: false,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action() {
  try {
    return await Api.getMeinenRessourcenPlan()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
